import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	noValuePlaceholder: {
		id: 'polaris-component-idea-view-bento-sidebar.idea-view.field-value.no-value-placeholder',
		defaultMessage: 'None',
		description: 'Placeholder for a field with no value',
	},
});
